import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  mutation RunIntegrationConnector(
    $tenantId: ID!
    $zoneId: ID!
    $connectorId: ID!
    $truncateModelIds: [ID!]
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        runIntegration(
          connectorId: $connectorId
          truncateModelIds: $truncateModelIds
        )
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.RunIntegrationConnectorMutation,
    boolean,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'runIntegration',
        transformers.PASS_THROUGH,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.RunIntegrationConnectorMutation,
  boolean,
  graphql.schema.RunIntegrationConnectorMutationVariables
>({ query: DOC, transformer: TRANSFORMER })
